import $$ from 'cmn-utils'

const baseUrl = "/api/sys/project-document/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },

}